import { vertexShader as blitVertex } from './blit-shader';

/** Use texture() + normalized UV (avoids textureSize/texelFetch issues on some drivers). */
const fragmentShader = /* glsl*/ `
    uniform sampler2D leftTexture;
    uniform sampler2D rightTexture;
    uniform vec2 deviceSize;

    void main(void) {
        vec2 fc = gl_FragCoord.xy;
        float fullW = deviceSize.x;
        float fullH = deviceSize.y;
        float halfW = floor(fullW * 0.5);
        float v = (fc.y + 0.5) / fullH;

        if (fc.x < halfW) {
            float u = (fc.x + 0.5) / halfW;
            gl_FragColor = texture(leftTexture, vec2(u, v));
        } else {
            float u = (fc.x - halfW + 0.5) / halfW;
            gl_FragColor = texture(rightTexture, vec2(u, v));
        }
    }
`;

const vertexShader = blitVertex;

export { vertexShader, fragmentShader };
